import styled from 'styled-components'

export const ImageContentWrapper = styled.div<{ $isDisabled: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;

  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};

  .animate > svg {
    width: 20px;
    height: 20px;
  }
`
